// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_2XI4z","hidden":"_1dn7r"};